export var getParticipantsCount = function getParticipantsCount(editorState) {
  var _collabEditPlugin$$pa, _collabEditPlugin$$pa2;
  // TODO: ED-15663
  // Please, do not copy or use this kind of code below
  // @ts-ignore
  if (!editorState || !editorState['collabEditPlugin$']) {
    return 1;
  }
  var participantsCount = (_collabEditPlugin$$pa = (_collabEditPlugin$$pa2 = editorState['collabEditPlugin$'].participants) === null || _collabEditPlugin$$pa2 === void 0 ? void 0 : _collabEditPlugin$$pa2.size()) !== null && _collabEditPlugin$$pa !== void 0 ? _collabEditPlugin$$pa : 1;
  return participantsCount;
};